export default "__VITE_ASSET__43e87fbe__"